import React, {Component} from 'react';
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import ClientService from "../../biletyApi/ClientService";
import {Form, FormControl} from "react-bootstrap";
import {TopButtonPointAction} from "../../../../../componentsTopsa/buttons/TopButtons";

export default class IleInTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            czyPokazacInput: false,
            ile: ''
        };
    }

    componentDidMount() {
        this.setState({
            ile: this.props.ile
        })
    }

    componentWillReceiveProps(nextprops) {
        this.setState({
            ile: nextprops.ile
        })
    }


    onClickSave() {
        if (this.state.ile <= 0) {
            alert("Nie można zmienić ilości na 0 badź mniejszą. Jeśli chcesz anulować bilet, użyj opcji zmiany statusu na anulowano operator.")
        }
        else {
            this.props.handleChangeIlosc(this.props.idBp, this.state.ile)
        }
        this.setState({czyPokazacInput:false})
    }

    render() {

        return (
            <div>
                {
                    Boolean(this.state.czyPokazacInput) ?
                        <Form>
                            <div style={{
                                display: "inline-block",
                                width: "100px"
                            }}>
                                <FormControl
                                    type={'number'}
                                    defaultValue={this.props.ile}
                                    value={this.state.ile}
                                    onChange={(e) => this.setState({ile: e.target.value})}
                                />
                            </div>
                            <TopButtonPointAction onClick={() => this.setState({czyPokazacInput: false, ile:this.props.ile})} buttonIcon={"fa fa-times"}
                                                  buttonColor={"default"}/>
                            <TopButtonPointAction onClick={() => this.onClickSave()} buttonIcon={"fa fa-save"} buttonColor={"primary"}/>
                        </Form>
                        :
                        <div>
                            <span>{this.props.ile}</span>
                            {
                                Boolean(this.props.canedit) ?
                                    <i className={'fa fa-pencil'} onClick={() => this.setState({czyPokazacInput: true})}
                                       style={{marginLeft: '5px', cursor: 'pointer'}}></i>
                                    : ""
                            }
                        </div>
                }

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyJednorazowe/components/IleInTable.js